class TermoDeUsoService extends EficienciaFiscalAbstractService

  configure: (configs, injector) ->
    configs.url = '/eficiencia-fiscal/termo-de-uso'

    super(configs, injector)

angular.module('eficienciaFiscalModule').service('termoDeUsoService', TermoDeUsoService)
